import { userManager } from "./auth";
// src/utils/authTokens.js
let accessToken = null;
let refreshToken = null;

export function saveTokens(access, refresh) {
  accessToken = access;
  refreshToken = refresh;
  sessionStorage.setItem("access_token", access);
  sessionStorage.setItem("refresh_token", refresh);
}

export function getAccessToken() {
  if (!accessToken) {
    accessToken = sessionStorage.getItem("access_token");
  }
  return accessToken;
}

export function getRefreshToken() {
  if (!refreshToken) {
    refreshToken = sessionStorage.getItem("refresh_token");
  }
  return refreshToken;
}

export function clearTokens() {
  accessToken = null;
  refreshToken = null;
  sessionStorage.removeItem("access_token");
  sessionStorage.removeItem("refresh_token");
}


export async function logout() {
  clearTokens();
    document.cookie = "JSESSIONID=; Max-Age=0; path=/"; // Remove JSESSIONID cookie
  // Clear all cookies
  document.cookie.split(";").forEach((c) => {
    document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });
      // Clear session and local storage completely
      sessionStorage.clear(); // Clear session storage
      localStorage.clear();
      clearTokens();
      
      // Clear tokens and other stored info
      await userManager.removeUser();
      const user = await userManager.getUser();
      console.log("After removeUser, user is:", user);
  
      // Redirect to login page
      
        window.location.href = "/";
     
}